/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TreatmentHistoryCategoryEnum = {
    Appointment: 'APPOINTMENT'
} as const;
export type TreatmentHistoryCategoryEnum = typeof TreatmentHistoryCategoryEnum[keyof typeof TreatmentHistoryCategoryEnum];

